import styled from "@emotion/styled";
import SelectList from "metabase/components/SelectList";

export const OptionsList = styled(SelectList)`
  padding: 0.5rem;
  min-width: 300px;
`;
